import { NodeModel, DrawOpts } from '../../../../types';
import { ItemState } from '../../../../constants';
import { shapeNames, groupIds } from '../../../../shapes/constants';
import { getChild } from '../../../../shapes/utils';

type State = ItemState | string;

export const getNodeIdText = (model: NodeModel) => {
  let idText;

  try {
    const liveWorkflowNodeId = model.liveWorkflowNodeId
      ? parseInt(model.liveWorkflowNodeId, 10)
      : null;
    const nodeId = parseInt(model.id, 10);
    const id = liveWorkflowNodeId ?? nodeId; // if we have a live node associated to the node, display the live node id
    idText = !Number.isNaN(id) && id >= 0 ? id : '-';
  } catch (e) {
    idText = '-';
  }

  return `Tile ID ${idText}`;
};

export const getDescBottomShape = (group: DrawOpts['group']) =>
  getChild(group, groupIds.descBottom);

export const getWrapperStateShapeAttrs = (
  state: string | ItemState,
  options: Record<string, any>,
) =>
  [ItemState.Active, ItemState.HighLight].includes(state as ItemState)
    ? { stroke: options.activeBorderColor }
    : {};

export const getUpdatedShapeAttrs = ({
  className = '',
  options = {},
  states = [],
}: {
  className: string;
  options: Record<string, any>;
  states: State[];
}) => {
  const shapeName = className;
  const styleName = shapeName;

  let shapeAttrs = options?.[styleName];

  states.forEach((state) => {
    const stateStyles = options?.stateStyles?.[state];

    if (!stateStyles) return;

    const updatedStyle = stateStyles[styleName] || {};

    // Uses the activeborder color as the wrpper class active border
    // if none has been provided in the hover overrides
    const updatedStateAttrs =
      className === shapeNames.wrapper
        ? { ...getWrapperStateShapeAttrs(state, options), ...updatedStyle }
        : updatedStyle;

    shapeAttrs = {
      ...shapeAttrs,
      ...updatedStateAttrs,
    };
  });

  return shapeAttrs;
};
